"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
const immer_1 = __importDefault(require("immer"));
const typesafe_actions_1 = require("typesafe-actions");
const types_1 = require("../types");
const actionCreators = __importStar(require("./actions"));
const initialState = {
    distributors: [],
    countries: [],
    states: [],
    customersConnectedToDistributor: [],
    version: { version: '' },
    isLoading: types_1.LOADING_STATE.LOADING,
    countriesWithDistributors: [],
    statesWithDistributors: [],
};
// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => (0, immer_1.default)(state, (draft) => {
    switch (action.type) {
        case (0, typesafe_actions_1.getType)(actionCreators.fetchDataSuccess): {
            draft.countries = action.payload.countries;
            draft.distributors = action.payload.distributors;
            draft.states = action.payload.states;
            draft.customersConnectedToDistributor = action.payload.customersConnectedToDistributor;
            draft.countriesWithDistributors = action.payload.countriesWithDistributors;
            draft.statesWithDistributors = action.payload.statesWithDistributors;
            draft.isLoading = types_1.LOADING_STATE.COMPLETE;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.fetchDataError): {
            draft.countries = initialState.countries;
            draft.distributors = initialState.distributors;
            draft.customersConnectedToDistributor = initialState.customersConnectedToDistributor;
            draft.states = initialState.states;
            draft.isLoading = types_1.LOADING_STATE.FAILED;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.fetchCustomersConnectedToDistributorSuccess): {
            draft.customersConnectedToDistributor = action.payload;
            // eslint-disable-next-line no-useless-return
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.fetchBundleVersionSuccess): {
            draft.version = action.payload;
            // eslint-disable-next-line no-useless-return
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.updateCustomerData): {
            draft.customersConnectedToDistributor = action.payload;
            break;
        }
        default:
            // eslint-disable-next-line no-useless-return
            return;
    }
});
exports.default = reducer;
